import { readJackpotAmount, readJackpotList } from '@/api/bet/read';
import Header from '@/component/Header';
import { jackpotListColumns } from '@/component/bet/table/BetColumnData';
import { Tables } from '@/component/pools/table/Tables';
import { packBigNumbers } from '@/lib/BigNumbers';
import { SUCCESS } from '@/lib/common/name-space';
import { Box, Button, Card, CardContent, Divider } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

// 잭팟 리스트 타입 정의 (실제 타입에 맞게 수정 필요)
interface JackpotListType {
  address: string;
  amount: string;
  regDt: string;
  jackpotId?: string;
}

export default function JackpotList() {
  const [list, setList] = useState<JackpotListType[]>([]);
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      const re = await readJackpotList();
      if (re.status !== SUCCESS) {
        return;
      }

      const data = re.data.map((item: JackpotListType, index: number) => ({
        ...item,
        index: index + 1,
        amount: packBigNumbers(item.amount),
      }));

      setList(data);

      const res = await readJackpotAmount();
      if (res.status !== SUCCESS) {
        return;
      }

      console.log(res);
    })();
  }, []);

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          overflow: 'auto',
          flex: 1,
          flexDirection: 'column',
          gap: { xs: '16px', sm: '0px' },
          height: '100vh',
          maxHeight: '100vh',
        }}
      >
        <Card>
          <Header title="잭팟 리스트" />
          <Divider />
          <Box mb={2} />
          {/* <Button
            variant="contained"
            onClick={() => {
              navigate('/jackpot');
            }}
          >
            신규 생성
          </Button> */}
          <CardContent sx={{ maxHeight: 'calc(100vh - 200px)', overflow: 'auto' }}>
            {list && <Tables list={list} columns={jackpotListColumns} getRowId={(row) => row.jackpotId} />}
          </CardContent>
        </Card>
      </Box>
    </>
  );
}
